import './SyncHealthNotification.scss';

import SyncHealthNotification from './SyncHealthNotification';

export default SyncHealthNotification;
